import React from 'react';
import {
  Button,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { getHostLabel } from 'views/sast2/helper';

const SelectAccountModal = ({
  hostType,
  connectedAccounts,
  onConnect,
  onClose,
}) => {
  //connectedAccounts:  [
  //   {id: 20, title: "github/naveed-ashraf-pk", host_type: "github"},
  //
  // ]

  const toggleModal = () => {
    onClose();
  };

  return (
    <Card>
      <Modal isOpen={true} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Select Your {getHostLabel(hostType)} Account
        </ModalHeader>
        <ModalBody>
          <div>
            <p>
              You already have the following {getHostLabel(hostType)} accounts
              configured. Please select one of those account(s) to connect your
              repositories for vulnerability scanning:
            </p>
            <ul className="list-unstyled">
              {connectedAccounts.map((account) => (
                <li key={account.id}>
                  {/* Call the handleConnect function on click */}
                  <Button color="link" onClick={() => onConnect(account.id)}>
                    {account.title}
                  </Button>
                </li>
              ))}
            </ul>
          </div>
          <p>Alternatively, connect a new account:</p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => onConnect(-1)}>
            Connect New Account
          </Button>{' '}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

export default SelectAccountModal;
